import React from 'react';
import { Navigate } from 'react-router-dom';

const RedirectToHome: React.FC = () => {
  return (
    <Navigate
      to='/'
      replace
    />
  );
};

export default RedirectToHome;
